import { Tooltip, withStyles } from '@material-ui/core';

export const DarkTooltip = withStyles({
  tooltip: {
    backgroundColor: '#1a1a1a',
    color: '#fff',
    fontSize: 11,
    fontWeight: 500,
    padding: '4px 8px',
    borderRadius: 5,
    boxShadow: '0 2px 8px rgba(0,0,0,.25)',
  },
  arrow: { color: '#1a1a1a' },
})(Tooltip);
